// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__2FzAz","label":"SetPasswdForm_label__3L04-"};